import { render } from "./EsqueciSenhaVie.vue?vue&type=template&id=34590526"
import script from "./EsqueciSenhaVie.vue?vue&type=script&lang=js"
export * from "./EsqueciSenhaVie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__